/* tslint:disable */
/* eslint-disable */
/**
 * RakuLogi API
 * RakuLogi の API ドキュメント
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ResponseSetItem } from './ResponseSetItem';
import {
    ResponseSetItemFromJSON,
    ResponseSetItemFromJSONTyped,
    ResponseSetItemToJSON,
    ResponseSetItemToJSONTyped,
} from './ResponseSetItem';

/**
 * 
 * @export
 * @interface ResponseRegistAmazonItemsResponse
 */
export interface ResponseRegistAmazonItemsResponse {
    /**
     * Amazon商品名
     * @type {string}
     * @memberof ResponseRegistAmazonItemsResponse
     */
    amazonItemName?: string;
    /**
     * 納品数
     * @type {number}
     * @memberof ResponseRegistAmazonItemsResponse
     */
    arriveCount?: number;
    /**
     * 
     * @type {string}
     * @memberof ResponseRegistAmazonItemsResponse
     */
    asin?: string;
    /**
     * 
     * @type {number}
     * @memberof ResponseRegistAmazonItemsResponse
     */
    baseId?: number;
    /**
     * セットなし時の予定入荷総数
     * @type {number}
     * @memberof ResponseRegistAmazonItemsResponse
     */
    expectedCount?: number;
    /**
     * セットなし時の賞味期限
     * @type {string}
     * @memberof ResponseRegistAmazonItemsResponse
     */
    expiryDate?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponseRegistAmazonItemsResponse
     */
    fnsku?: string;
    /**
     * JANコード
     * @type {string}
     * @memberof ResponseRegistAmazonItemsResponse
     */
    jan?: string;
    /**
     * Amazonセット数
     * @type {number}
     * @memberof ResponseRegistAmazonItemsResponse
     */
    setCount?: number;
    /**
     * セット情報（1セット＝1行）
     * @type {Array<ResponseSetItem>}
     * @memberof ResponseRegistAmazonItemsResponse
     */
    setItems?: Array<ResponseSetItem>;
    /**
     * 
     * @type {string}
     * @memberof ResponseRegistAmazonItemsResponse
     */
    sku?: string;
    /**
     * 保管場所
     * @type {string}
     * @memberof ResponseRegistAmazonItemsResponse
     */
    storageLocation?: string;
    /**
     * 
     * @type {number}
     * @memberof ResponseRegistAmazonItemsResponse
     */
    tenantId?: number;
    /**
     * 
     * @type {number}
     * @memberof ResponseRegistAmazonItemsResponse
     */
    userId?: number;
}

/**
 * Check if a given object implements the ResponseRegistAmazonItemsResponse interface.
 */
export function instanceOfResponseRegistAmazonItemsResponse(value: object): value is ResponseRegistAmazonItemsResponse {
    return true;
}

export function ResponseRegistAmazonItemsResponseFromJSON(json: any): ResponseRegistAmazonItemsResponse {
    return ResponseRegistAmazonItemsResponseFromJSONTyped(json, false);
}

export function ResponseRegistAmazonItemsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseRegistAmazonItemsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'amazonItemName': json['amazon_item_name'] == null ? undefined : json['amazon_item_name'],
        'arriveCount': json['arrive_count'] == null ? undefined : json['arrive_count'],
        'asin': json['asin'] == null ? undefined : json['asin'],
        'baseId': json['base_id'] == null ? undefined : json['base_id'],
        'expectedCount': json['expected_count'] == null ? undefined : json['expected_count'],
        'expiryDate': json['expiry_date'] == null ? undefined : json['expiry_date'],
        'fnsku': json['fnsku'] == null ? undefined : json['fnsku'],
        'jan': json['jan'] == null ? undefined : json['jan'],
        'setCount': json['set_count'] == null ? undefined : json['set_count'],
        'setItems': json['set_items'] == null ? undefined : ((json['set_items'] as Array<any>).map(ResponseSetItemFromJSON)),
        'sku': json['sku'] == null ? undefined : json['sku'],
        'storageLocation': json['storage_location'] == null ? undefined : json['storage_location'],
        'tenantId': json['tenant_id'] == null ? undefined : json['tenant_id'],
        'userId': json['user_id'] == null ? undefined : json['user_id'],
    };
}

export function ResponseRegistAmazonItemsResponseToJSON(json: any): ResponseRegistAmazonItemsResponse {
    return ResponseRegistAmazonItemsResponseToJSONTyped(json, false);
}

export function ResponseRegistAmazonItemsResponseToJSONTyped(value?: ResponseRegistAmazonItemsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'amazon_item_name': value['amazonItemName'],
        'arrive_count': value['arriveCount'],
        'asin': value['asin'],
        'base_id': value['baseId'],
        'expected_count': value['expectedCount'],
        'expiry_date': value['expiryDate'],
        'fnsku': value['fnsku'],
        'jan': value['jan'],
        'set_count': value['setCount'],
        'set_items': value['setItems'] == null ? undefined : ((value['setItems'] as Array<any>).map(ResponseSetItemToJSON)),
        'sku': value['sku'],
        'storage_location': value['storageLocation'],
        'tenant_id': value['tenantId'],
        'user_id': value['userId'],
    };
}

